import React from 'react'
import { Input } from '@/components/shadcn/input'
import { IconCloseOutline } from '@icons/IconCloseOutline'
import { cn } from '@/lib/utils'
import { IconV2SearchOutline } from '@icons/IconV2SearchOutline'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  inputClassName?: string
  autoFocus?: boolean
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className,
  inputClassName,
  autoFocus = false,
}: SearchInputProps) {
  return (
    <div className={cn('relative w-48', className)}>
      <Input
        placeholder={placeholder}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        className={cn('h-9 w-full pl-8 pr-8', inputClassName)}
        autoFocus={autoFocus}
      />
      <IconV2SearchOutline size={20} className="absolute left-2.5 top-1/2 -translate-y-[40%] text-muted-foreground" />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus:ring-1 focus:ring-ring"
        >
          <IconCloseOutline size={14} />
        </button>
      )}
    </div>
  )
}
